module.exports = __webpack_public_path__ + "img/logo-nav.5b3c793c.png";